import React from "react";
const constTempData = [
  {
    sectorETF: "S&P 500",
    ticker: "SPY",
  },
  {
    sectorETF: "Consumer Discretionary",
    ticker: "XLY",
  },
  {
    sectorETF: "Consumer Staples Sector",
    ticker: "XLP",
  },
  {
    sectorETF: "Communications Select Sector",
    ticker: "XLC",
  },
  {
    sectorETF: "Energy Select Sector",
    ticker: "XLE",
  },
  {
    sectorETF: "Financial Select Sector",
    ticker: "XLF",
  },
  {
    sectorETF: "Health Care Select Sector",
    ticker: "XLV",
  },
  {
    sectorETF: "Industrial Select Sector",
    ticker: "XLI",
  },
  {
    sectorETF: "Transports",
    ticker: "IYT",
  },
  {
    sectorETF: "Technology Select Sector",
    ticker: "XLK",
  },
  {
    sectorETF: "Semiconductors",
    ticker: "SMH",
  },
  {
    sectorETF: "Materials Select Sector",
    ticker: "XLB",
  },
  {
    sectorETF: "Metals & Mining",
    ticker: "XME",
  },
  {
    sectorETF: "Homebuilders",
    ticker: "XHB",
  },
  {
    sectorETF: "Real Estate Select Sector",
    ticker: "XLRE",
  },
  {
    sectorETF: "Utilities Select Sector",
    ticker: "XLU",
  },
];

const dict = {
  signal: "algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH",
  price: "algo_eod_PX_LAST",
  "1d": "current_trr_1d",
  "1w": "current_trr_5d",
  "1m": "current_trr_1mo",
  "3m": "current_trr_3mo",
  ytd: "current_trr_ytd",
};
const SectorPerformanceData = ({ testData, sortData, refresh }) => {
  const [originalData, setOriginalData] = React.useState([]);
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    const tempData = constTempData;
    tempData.map((obj) => (obj.testData = testData[obj.ticker]));
    originalData.length === 0 && setOriginalData(tempData);
    setData(tempData);
  }, [originalData.length, testData]);

  React.useEffect(() => {
    if (data.length > 0) {
      if (sortData.startsWith("high-low")) {
        const sortKey = dict[sortData.split("-")[2]];
        setData(data.sort((a, b) => a.testData[sortKey] - b.testData[sortKey]));
        refresh();
      } else if (sortData.startsWith("low-high")) {
        const sortKey = dict[sortData.split("-")[2]];
        setData(data.sort((a, b) => b.testData[sortKey] - a.testData[sortKey]));
        refresh();
      } else {
        setData(originalData);
        refresh();
      }
    }
    // eslint-disable-next-line
  }, [sortData, data, originalData]);

  // function greaterThanZero(color) {
  //   return color === null ? "white" : color ? "red" : "green";
  // }

  const signalColor = (index, i) => {
    let signalStrength = 0;
    if (data[i].testData.algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH) {
      signalStrength = Math.round(
        data[i].testData.algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH * 10,
      );
      if (signalStrength >= 10) {
        signalStrength = 10;
      }
    }
    let primaryColor = "#ffffff";
    let halfColor = "linear-gradient(#3E3E3E 50%, #ffffff 50%)";
    let neutralColor = "#3E3E3E";
    if (data[i].testData.algo_eod_CALC_POSITION_LONGBOW_SIGNAL === "Buy") {
      primaryColor = "#75CE41";
      halfColor = "linear-gradient(#3E3E3E 50%, #75CE41 50%)";
      neutralColor = "#3E3E3E";
    }
    if (data[i].testData.algo_eod_CALC_POSITION_LONGBOW_SIGNAL === "Sell") {
      primaryColor = "#D33541";
      halfColor = "linear-gradient(#57262B 50%, #D33541 50%)";
      neutralColor = "#57262B";
    }
    const style = [
      [neutralColor, neutralColor, neutralColor, neutralColor, neutralColor],
      [halfColor, neutralColor, neutralColor, neutralColor, neutralColor],
      [primaryColor, neutralColor, neutralColor, neutralColor, neutralColor],
      [primaryColor, halfColor, neutralColor, neutralColor, neutralColor],
      [primaryColor, primaryColor, neutralColor, neutralColor, neutralColor],
      [primaryColor, primaryColor, halfColor, neutralColor, neutralColor],
      [primaryColor, primaryColor, primaryColor, neutralColor, neutralColor],
      [primaryColor, primaryColor, primaryColor, halfColor, neutralColor],
      [primaryColor, primaryColor, primaryColor, primaryColor, neutralColor],
      [primaryColor, primaryColor, primaryColor, primaryColor, halfColor],
      [primaryColor, primaryColor, primaryColor, primaryColor, primaryColor],
    ][signalStrength];
    return style[index];
  };
  return data.map((row, i) => {
    return (
      <div className="asset-info-row" key={i}>
        <div className="cell-first" style={{ paddingLeft: 20 }}>
          {row.sectorETF}
        </div>
        <div
          className={`cell-first`}
          style={{ display: "block", textAlign: "center", margin: "auto" }}
        >
          {row.ticker}
        </div>
        <div className={`cell-first`} style={{ justifySelf: "center" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              justifyContent: "space-around",
              width: 40,
              marginLeft: -5,
              transform: "scale(0.5)",
            }}
          >
            <div
              style={{
                height: 10,
                width: 5,
                backgroundImage: signalColor(0, i).startsWith("l")
                  ? signalColor(0, i)
                  : "unset",
                backgroundColor: signalColor(0, i),
                borderRadius: 20,
              }}
            ></div>
            <div
              style={{
                height: 15,
                width: 5,
                backgroundImage: signalColor(1, i).startsWith("l")
                  ? signalColor(1, i)
                  : "unset",
                backgroundColor: signalColor(1, i),
                borderRadius: 20,
              }}
            ></div>
            <div
              style={{
                height: 20,
                width: 5,
                backgroundImage: signalColor(2, i).startsWith("l")
                  ? signalColor(2, i)
                  : "unset",
                backgroundColor: signalColor(2, i),
                borderRadius: 20,
              }}
            ></div>
            <div
              style={{
                height: 25,
                width: 5,
                backgroundImage: signalColor(3, i).startsWith("l")
                  ? signalColor(3, i)
                  : "unset",
                backgroundColor: signalColor(3, i),
                borderRadius: 20,
              }}
            ></div>
            <div
              style={{
                height: 30,
                width: 5,
                backgroundImage: signalColor(4, i).startsWith("l")
                  ? signalColor(4, i)
                  : "unset",
                backgroundColor: signalColor(4, i),
                borderRadius: 20,
              }}
            ></div>
          </div>
        </div>
        {data[i].testData && (
          <>
            <div
              className={`cell-info`}
              style={
                data[i].testData.current_trr_1d.toFixed(2) === 0.0
                  ? { color: "white" }
                  : data[i].testData.current_trr_1d > 0
                  ? { color: "#75CE41" }
                  : data[i].testData.current_trr_1d < 0
                  ? { color: "#D33541" }
                  : { color: "gray" }
              }
            >
              $
              {data[i].testData.algo_eod_PX_LAST > 0
                ? data[i].testData.algo_eod_PX_LAST.toFixed(2)
                : "- - -"}
            </div>
            <div
              className="cell-info"
              style={
                data[i].testData.current_trr_1d.toFixed(2) === 0.0
                  ? { color: "white" }
                  : data[i].testData.current_trr_1d > 0
                  ? { color: "#75CE41" }
                  : data[i].testData.current_trr_1d < 0
                  ? { color: "#D33541" }
                  : { color: "gray" }
              }
            >
              {data[i].testData.current_trr_1d.toFixed(2)}%
            </div>
            <div
              className="cell-info"
              style={
                data[i].testData.current_trr_5d.toFixed(2) === 0.0
                  ? { color: "white" }
                  : data[i].testData.current_trr_5d > 0
                  ? { color: "#75CE41" }
                  : data[i].testData.current_trr_5d < 0
                  ? { color: "#D33541" }
                  : { color: "gray" }
              }
            >
              {data[i].testData.current_trr_5d.toFixed(2)}%
            </div>
            <div
              className="cell-info"
              style={
                data[i].testData.current_trr_1mo.toFixed(2) === 0.0
                  ? { color: "white" }
                  : data[i].testData.current_trr_1mo > 0
                  ? { color: "#75CE41" }
                  : data[i].testData.current_trr_1mo < 0
                  ? { color: "#D33541" }
                  : { color: "gray" }
              }
            >
              {data[i].testData.current_trr_1mo.toFixed(2)}%
            </div>
            <div
              className="cell-info"
              style={
                data[i].testData.current_trr_3mo.toFixed(2) === 0.0
                  ? { color: "white" }
                  : data[i].testData.current_trr_3mo > 0
                  ? { color: "#75CE41" }
                  : data[i].testData.current_trr_3mo < 0
                  ? { color: "#D33541" }
                  : { color: "gray" }
              }
            >
              {data[i].testData.current_trr_3mo.toFixed(2)}%
            </div>
            <div
              className="cell-info"
              style={
                data[i].testData.current_trr_ytd.toFixed(2) === 0.0
                  ? { color: "white" }
                  : data[i].testData.current_trr_ytd > 0
                  ? { color: "#75CE41" }
                  : data[i].testData.current_trr_ytd < 0
                  ? { color: "#D33541" }
                  : { color: "gray" }
              }
            >
              {data[i].testData.current_trr_ytd.toFixed(2)}%
            </div>
          </>
        )}
      </div>
    );
  });
};

export default SectorPerformanceData;
